import React, { useState } from "react";
import { Helmet, HelmetProvider } from "react-helmet-async";
import { Link } from "react-router-dom";

export default function Beratungsfelder() {
	return (
		<>
			<div className="beratungs-menu">
				<HelmetProvider>
					<Helmet>
						<title>Beratungsfelder</title>
						<meta
							name="description"
							content="Beratungsfelder Prozessberatung"
						/>
						<meta
							name="keywords"
							content="Beratungsfelder, Feingeist, Prozessberatung, Berlin"
						/>
					</Helmet>
				</HelmetProvider>
				<div className="box-menu">
					<div className="field-preview">
						<div className="picture-cards-lg beratun_icons">
							<Link
								to="/beratungsfelder/fokusthema"
								className="picture-cards-lg__card beratun_Fokusthema animated-div"
							>
								<span className="picture-cards-lg__card-title ">
									<span className="picture-cards-lg__card-title-wrapper">
										Digitalisierungs- und Prozessberatung
									</span>
								</span>
							</Link>
							<Link
								to="/beratungsfelder/deal_advisory"
								className="picture-cards-lg__card beratun_Deal animated-div"
							>
								<span className="picture-cards-lg__card-title ">
									<span className="picture-cards-lg__card-title-wrapper">
										Unternehmenskäufe- und verkäufe / Nachfolgelösung
									</span>
								</span>
							</Link>
						</div>
					</div>
					<div className="field-preview">
						<div className="picture-cards-lg beratun_icons">
							<Link
								to="/beratungsfelder/corporate_advisory"
								className="picture-cards-lg__card beratun_Corporate animated-div"
							>
								<span className="picture-cards-lg__card-title ">
									<span className="picture-cards-lg__card-title-wrapper">
										Strategische Beratung
									</span>
								</span>
							</Link>
							<Link
								to="/beratungsfelder/esg_advisory"
								className="picture-cards-lg__card beratun_ESG animated-div"
							>
								<span className="picture-cards-lg__card-title ">
									<span className="picture-cards-lg__card-title-wrapper">
										ESG-Beratung
									</span>
								</span>
							</Link>
						</div>
					</div>
				</div>

				<aside className="contact-sec beratun_kontakt">
					<p>
						Setzen Sie sich mit uns in Verbindung und lassen Sie sich
						unverbindlich beraten.
					</p>
					<a className="link-button" href="/kontakt">
						Kontaktieren Sie uns
					</a>
				</aside>
			</div>
		</>
	);
}
